let liveChatTrackingLoaded = false;

function loadLiveChatTracking() {
  if (liveChatTrackingLoaded === false) {
    // Define Engagement type (1 == proactive)
    let chatEngagementType = 0;

    if (
      Object.prototype.hasOwnProperty.call(window, 'lpTag') &&
      Object.prototype.hasOwnProperty.call(window.lpTag, 'events')
    ) {
      // Livechat Engagements are displayed on the page
      liveChatTrackingLoaded = true;
      window.lpTag.events.bind({
        eventName: 'OFFER_DISPLAY',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        func: function (eventData: any) {
          if (eventData.engagementType === 1) {
            // engagementType === 1 indicates that this is a proactive invite
            window.site?.elcEvents?.dispatch(
              'track:liveChatProactiveDisplayed',
            );
          }
        },
      });

      // Livechat was clicked on the page
      window.lpTag.events.bind({
        eventName: 'OFFER_CLICK',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        func: function (eventData: any) {
          chatEngagementType = eventData.engagementType;
          if (eventData.engagementType === 1) {
            // engagementType === 1 indicates that this is a proactive invite
            window.site?.elcEvents?.dispatch(
              'track:liveChatProactiveInitiated',
            );
          } else {
            // otherwise it was manual`
            window.site?.elcEvents?.dispatch('track:liveChatManualInitiated');
          }
        },
      });

      // Livechat state change.
      window.lpTag.events.bind({
        eventName: 'state',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        func: function (eventData: any) {
          let engagementType = '';
          if (chatEngagementType === 1) {
            engagementType = 'Proactive';
          } else {
            engagementType = 'Manual';
          }
          if (eventData.state === 'preChat') {
            // When the survey before the chat is shown
            window.site?.elcEvents?.dispatch(
              'track:liveChat' + engagementType + 'PreSurvey',
            );
          }
          if (eventData.state === 'waiting') {
            // When the user submits the survey
            window.site?.elcEvents?.dispatch(
              'track:liveChat' + engagementType + 'Waiting',
            );
          }
          if (eventData.state === 'chatting') {
            // When the chat starts
            window.site?.elcEvents?.dispatch(
              'track:liveChat' + engagementType + 'Chatting',
            );
          }
        },
      });
    }
  }
}

export function init() {
  // Testing tracking signal from Tealium
  window.site?.elcEvents?.addListener('tealium:liveperson-loaded', function () {
    // Load the tracking after we launch LivePerson from Tealium
    window.dispatchEvent(new CustomEvent('lp.liveChatEvent'));
    loadLiveChatTracking();
  });

  // Load the tracking when we've implemented LivePerson from Drupal
  loadLiveChatTracking();
}
